<template>
  <div>
    <!-- <filed v-for="(item,key) in arr" :key="key" @titleTxt="title(value,key)"></filed> -->

    <div class="container">
      <Form :model="dispense" prop="dispense" label-position="left" :label-width="80" :rules="ruleDispense">
        <FormItem label="企业代码" v-if="getControl() == 1">
          <Input v-model="dispense.ClientCode" @click="SelectClientSwitch = !SelectClientSwitch" placeholder="企业代码"
            style="width: 100px"></Input>
        </FormItem>

        <FormItem label="代理编号" prop="Code">
          <Input v-model="dispense.Code" placeholder="代理编号" @click="onSelectDealer = !onSelectDealer"
            style="width: 150px"></Input>
        </FormItem>

        <FormItem label="代理名称" prop="Name">
          <Input v-model="dispense.Name" placeholder="代理名称" @click="onSelectDealer = !onSelectDealer"
            style="width: 150px"></Input>
        </FormItem>

        <FormItem label="产品编号" prop="title">
          <Input v-model="dispense.title" placeholder="选择产品" @click="onSelectProduct = !onSelectProduct"
            style="width: 150px"></Input>
        </FormItem>

        <FormItem label="产品名称" prop="product">
          <Input v-model="dispense.product" placeholder="产品名称" @click="onSelectProduct = !onSelectProduct"
            style="width: 150px"></Input>
        </FormItem>

        <FormItem label="分发号段" prop="SerialHead">
          <Input v-model="dispense.SerialHead" placeholder="开始号段" style="width: 150px" number @keyup="sizes()"></Input>
          -
          <Input prop="SerialEnd" v-model="dispense.SerialEnd" placeholder="结束号段" style="width: 150px" number
            @keyup="sizes()"></Input>
          {{ size + " 个" }}
        </FormItem>

        <FormItem label="状态">
          <i-switch v-model="dispense.state" size="large">
            <template #open>
              <span>启用</span>
            </template>
            <template #close>
              <span>禁用</span>
            </template>
          </i-switch>
        </FormItem>

        <FormItem label="备注说明" prop="remark">
          <Input v-model="dispense.remark" type="textarea" :autosize="{ minRows: 2, maxRows: 5 }"
            placeholder="请备注说明..."></Input>
        </FormItem>
      </Form>
    </div>

    <div class="btn">
      <Button @click="echo()" type="success" style="width: 100px; height: 40px">保&nbsp;存</Button>
    </div>

    <!-- 选择企业 -->
    <transition name="fade">
      <SelectClient v-if="SelectClientSwitch" @Value="SelectClientVal" @close="SelectClientClose"></SelectClient>
    </transition>

    <!-- 选择经销商 -->
    <transition name="fade">
      <selectDealer v-if="onSelectDealer" @Value="selectDealerData" @closeDealer="SelectDealerClose"></selectDealer>
    </transition>

    <!-- 选择产品 -->
    <transition name="fade">
      <selectProduct v-if="onSelectProduct" @Value="selectProductData" @closeDealer="selectProductClose"></selectProduct>
    </transition>
  </div>
</template>

<script>
import FiledUpload from "@/views/FiledUpload";
import { setDispense } from "@/api/index";
import SelectClient from "@/views/selectClient";
import selectDealer from "@/views/selectDealer";
import selectProduct from "@/views/selectProduct";
import { mapState } from "vuex";
export default {
  data() {
    return {
      dispense: {
        ClientCode: "",
        Code: "",
        Name: "",
        remark: "",
        SerialHead: "",
        SerialEnd: "",
        state: "",
        product: "",
        title: "",
      },
      ruleDispense: {},
      size: 0,
      SelectClientSwitch: false,
      onSelectDealer: false,
      onSelectProduct: false,
    };
  },
  components: {
    SelectClient,
    FiledUpload,
    selectDealer,
    selectProduct,
  },
  computed: mapState({
    control: (state) => state.control,
  }),
  watch: {},
  methods: {
    sizes() {
      this.size = this.dispense.SerialEnd - this.dispense.SerialHead + 1;
    },
    // 选择客户回调
    selectDealerData(v) {
      this.dispense.Code = v.u_code;
      this.dispense.Name = v.u_name;

      console.log(v);
    },

    //获取权限
    getControl() {
      return this.control;
    },
    SelectClientClose() {
      this.SelectClientSwitch = false;
    },
    SelectDealerClose() {
      this.onSelectDealer = false;
    },
    selectProductClose() {
      this.onSelectProduct = false;
    },
    SelectClientVal(value) {
      this.dispense.ClientCode = value;
      this.SelectClientSwitch = false;
    },

    // 选择产品的回参
    selectProductData(obj) {
      this.onSelectProduct = false;
      this.dispense.product = obj.ProductName;
      this.dispense.title = obj.title;
    },
    setDispenses() {
      setDispense({
        ClientCode: this.dispense.ClientCode,
        // 开始流水号
        serial_head: this.dispense.SerialHead,
        // 结束流水号
        serial_end: this.dispense.SerialEnd,
        // 客户id
        client_id: this.dispense.Code,
        // 状态
        state: this.dispense.state,
        // 备注
        remark: this.dispense.remark,
        // 客户名称
        client_name: this.dispense.Name,
        // 产品编号
        product_code: this.dispense.title,
        // 产品名称
        product_name: this.dispense.product,
      }).then((res) => {
        if (res == 1) {
          this.$emit("close", true);
        }
      });
    },
    // 完成按钮
    echo() {
      if (this.dispense.SerialHead === "") {
        this.$message({
          type: "error",
          message: "开始号段不能为空!",
        });
      } else if (this.dispense.SerialEnd === "") {
        this.$message({
          type: "error",
          message: "结束号段不能为空!",
        });
      } else if (this.dispense.Code === "") {
        this.$message({
          type: "error",
          message: "请先选择客户!",
        });
      } else if (this.dispense.title === "") {
        this.$message({
          type: "error",
          message: "请先选择产品!",
        });
      } else {
        this.setDispenses();
        this.dispense = {
          ClientCode: "",
          Code: "",
          Name: "",
          remark: "",
          SerialHead: "",
          SerialEnd: "",
          state: "",
        };
      }
    },
  },
};
</script>

<style scoped>
.container {
  max-height: calc(100% - 100px);
}

.containers {
  width: 100%;
  display: flex;
  flex-direction: row;
  padding: 10px;
}

.line {
  line-height: 32px;
}

.jian {
  margin-left: 10px;
  height: 32px;
  width: 32px;
  cursor: pointer;
}

.jian_img {
  width: 100%;
}
</style>
